import { useCallback } from 'react';
import { useStudentActivitiesQuery } from 'src/dictionaries/dictionariesApi';

export const useActivityTranslation = () => {
  const { data: activities = [] } = useStudentActivitiesQuery();

  const translateActivity = useCallback(
    (activityKey: string) => {
      const activityDict = activities.find((item) => item.key === activityKey);
      return activityDict?.value || activityKey;
    },
    [activities],
  );

  return { translateActivity };
};
